function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".kg-loading-wrap{\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 10000;\r\n}\r\n.kg-loading .kg-loading-container .kg-loading-msg span {\r\n    color: #000;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon {\r\n    width: .55em;\r\n    height: .55em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg {\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.inline .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n.kg-loading.block .kg-loading-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon {\r\n    width: .88em;\r\n    height: .88em;\r\n    position: relative;\r\n    -ms-flex-negative: 0;\r\n        flex-shrink: 0;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-icon canvas {\r\n    position: absolute;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg {\r\n    margin-top: .1em;\r\n    -ms-flex-negative: 1;\r\n        flex-shrink: 1;\r\n}\r\n\r\n.kg-loading.block .kg-loading-container .kg-loading-msg span {\r\n    font-size: .24em;\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.kg-loading.pop {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container {\r\n    padding: .2em;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    border-radius: .1em;\r\n    overflow: hidden;\r\n    z-index: 10000;\r\n}\r\n\r\n.kg-loading.pop .kg-loading-container .kg-loading-msg span {\r\n    color: #fff;\r\n}\r\n\r\n.kg-loading.pop.popBg .kg-loading-bg {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n\r\n\r\n.kg-loading-icon.blue {\r\n    background: url(https://webimg.kgimg.com/c47e54633d8bd65701629ac3f3e6ee9f.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.blue:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/a76d10d8a9d930969330a396361f9a4a.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n.kg-loading-icon.red {\r\n    background: url(https://webimg.kgimg.com/d882096843e8ba444368cb31e77e975d.png) no-repeat top center;\r\n    background-size: 100%;\r\n}\r\n\r\n.kg-loading-icon.red:before {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    background: url(https://webimg.kgimg.com/44b471990022a7f0673aee8d0933145e.png) no-repeat;\r\n    background-size: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-animation: rotateAni 1s linear infinite;\r\n    animation: rotateAni 1s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes rotateAni {\r\n    0% {\r\n        -webkit-transform: rotate(0);\r\n        transform: rotate(0);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.kg-loading-svg{width:100%;display:block;}\r\n\r\n/* kugou11版本 */\r\n/*\r\n  计算方法: (dashoffset_min / dashoffset_max * rotate / 2)\r\n  比如: 620/916*360/2\r\n*/\r\n@-webkit-keyframes kg-loading_roll_11 {\r\n  0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}\r\n  50%{-webkit-transform:rotate(122deg);transform:rotate(122deg);}\r\n  100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}\r\n}\r\n@keyframes kg-loading_roll_11 {\r\n  0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}\r\n  50%{-webkit-transform:rotate(122deg);transform:rotate(122deg);}\r\n  100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}\r\n}\r\n\r\n@-webkit-keyframes kg-loading_dashoffset_11 {\r\n  0%{stroke-dashoffset:220;}\r\n  50%{stroke-dashoffset:149;}\r\n  100%{stroke-dashoffset:220;}\r\n}\r\n@keyframes kg-loading_dashoffset_11 {\r\n  0%{stroke-dashoffset:220;}\r\n  50%{stroke-dashoffset:149;}\r\n  100%{stroke-dashoffset:220;}\r\n}\r\n\r\n.kg-loading-svg .kg-loading-K,\r\n.kg-loading-svg .kg-loading-R{stroke:rgb(94, 206, 247);\r\n    -webkit-transition:stroke 0.3s;\r\n    transition:stroke 0.3s;\r\n}\r\n.kg-loading-svg .kg-loading-R{\r\n    -webkit-animation:kg-loading_roll_11 1.08s linear infinite;\r\n    animation:kg-loading_roll_11 1.08s linear infinite;\r\n    -webkit-transform-origin:50% 50%;\r\n    transform-origin:50% 50%;\r\n}\r\n.kg-loading-svg .kg-loading-C{\r\n    -webkit-animation:kg-loading_dashoffset_11 1.08s linear infinite;\r\n    animation:kg-loading_dashoffset_11 1.08s linear infinite;\r\n}\r\n.kg-loading-svg .kg-loading-BG{fill:rgba(94, 206, 247, 0.1);}\r\n.kg-loading-svg.kg-loading-warn .kg-loading-BG{fill:rgba(254, 180, 84, 0.1);}\r\n.kg-loading-svg.kg-loading-warn .kg-loading-K,\r\n.kg-loading-svg.kg-loading-warn .kg-loading-R{stroke:rgb(254, 180, 84);}";
styleInject(css);
/**
 * Canvas
 * @param {*} elem 
 * @param {*} opts 
 */

var iconInit = function iconInit(elem, opts) {
  if (typeof elem === 'string') {
    elem = document.querySelector(elem);
  } else if (elem.nodeType !== 1) {
    console.error('elem is not an Element Node');
    return;
  }

  var defaultOptions = {
    color: false,
    // 'normal', 'error', other_colors
    width: 48,
    stop: false,
    dpr: window.devicePixelRatio || 2
  };
  opts = Object.assign({}, defaultOptions, opts || {});
  var colorBlue = '#409EFF';
  var colorError = '#FF6C00';
  var KWBase = 6.6 / 144;
  var KPBase = [['moveTo', 59 / 144, 44 / 144], ['lineTo', 55 / 144, 100 / 144], ['moveTo', 90 / 144, 48 / 144], ['lineTo', 65 / 144, 70 / 144], ['lineTo', 89 / 144, 100 / 144]];
  var cache = {
    moveAngle: 0,
    secondAngle: Math.PI,
    endAngle: Math.PI / 8,
    add: 1,
    defaultSpeed: 1280 / (2 * Math.PI),
    // 根据options变化
    cvsWidth: 0,
    // 画布宽
    lineWidth: 0,
    // 线条宽
    radius: 0,
    // 半径
    center: {
      x: 0,
      y: 0
    },
    // 中心点
    KPoints: [],
    // K的路径关键点
    color: colorBlue,
    drawing: false
  };
  var cvs = document.createElement('canvas');

  if (!cvs.getContext) {
    return false;
  }

  var ctx = cvs.getContext("2d");
  cvs.style.maxWidth = '100%';
  cvs.style.maxHeight = '100%';
  cvs.style.verticalAlign = 'top';

  var changeOptions = function changeOptions(newOptions) {
    Object.assign(opts, newOptions || {});
    var W = cache.cvsWidth = (opts.width || 144) * opts.dpr;
    cache.color = !opts.color || opts.color === 'normal' ? colorBlue : opts.color === 'error' ? colorError : opts.color;
    cache.lineWidth = W * KWBase;
    cache.KPoints = KPBase.map(function (_) {
      return _.map(function (__) {
        return typeof __ === 'string' ? __ : W * __;
      });
    });
    cache.center = {
      x: W / 2,
      y: W / 2
    };
    cache.radius = W / 2 - cache.lineWidth;
    cvs.width = W;
    cvs.height = W;
    cvs.style.width = opts.width + 'px';
    cvs.style.height = opts.width + 'px';

    if (!opts.stop && cache.drawing === false) {
      draw();
    }
  };

  var draw = function draw(step) {
    cache.drawing = true;
    var C = cache.center;
    var R = cache.radius; // const KP = cache.KPoints

    var SP = step || cache.defaultSpeed;
    ctx.clearRect(0, 0, cache.cvsWidth, cache.cvsWidth);
    ctx.lineCap = "round";
    ctx.fillStyle = "#f2f2f2";
    ctx.strokeStyle = cache.color; // 绘制背景

    ctx.beginPath();
    ctx.arc(C.x, C.y, R - cache.lineWidth * 1.5, 0, Math.PI * 2, false);
    ctx.fill();
    ctx.save(); // 绘制K

    ctx.lineWidth = cache.lineWidth * 1.82;
    ctx.beginPath();
    cache.KPoints.map(function (_) {
      ctx[_[0]](_[1], _[2]);
    }); // ctx.moveTo(KP[0][0], KP[0][1])
    // ctx.lineTo(KP[1][0], KP[1][1])
    // ctx.moveTo(KP[2][0], KP[2][1])
    // ctx.lineTo(KP[3][0], KP[3][1])
    // ctx.lineTo(KP[4][0], KP[4][1])

    ctx.stroke(); // 绘制外框线条动画

    ctx.lineWidth = cache.lineWidth;
    ctx.beginPath();
    ctx.arc(C.x, C.y, R, cache.moveAngle, cache.moveAngle + cache.endAngle, false);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(C.x, C.y, R, cache.moveAngle + cache.secondAngle, cache.moveAngle + cache.secondAngle + cache.endAngle, false);
    ctx.stroke();
    cache.moveAngle += SP;

    if (cache.moveAngle >= 2 * Math.PI) {
      cache.moveAngle = 0;
    }

    if (cache.endAngle >= Math.PI / 3) {
      cache.endAngle = Math.PI / 3;
      cache.add = 0;
    } else if (cache.endAngle <= Math.PI / 24) {
      cache.endAngle = Math.PI / 24;
      cache.add = 1;
    }

    if (cache.add) {
      cache.endAngle += SP / 2;
    } else {
      cache.endAngle -= SP / 2;
      cache.moveAngle += SP / 2;
    }

    cache.lastTime = Date.now();
    requestAnimationFrame(function () {
      // 如果元素被删除，就不继续循环了
      // if (cvs.parentNode && cvs.parentNode.parentNode && !opts.stop) {//<----有bug，实际上没删掉dom的引用
      if (cvs.offsetWidth != 0 && !opts.stop) {
        // 动画时长1280ms
        var _step = (Date.now() - cache.lastTime) * 2 * Math.PI / 1280;

        draw(_step);
      } else {
        cache.drawing = false;
        cvs = null;
      }
    });
  };

  elem.appendChild(cvs);
  changeOptions();
  return {
    draw: draw,
    changeOptions: changeOptions
  };
};
/**
 * 酷狗11
 * @param {*} elem 
 * @param {*} opts 
 * @returns 
 */


var kg11Init = function kg11Init(elem, opts) {
  if (typeof elem === 'string') {
    elem = document.querySelector(elem);
  } else if (elem.nodeType !== 1) {
    console.error('elem is not an Element Node');
    return false;
  }

  var supportSVG = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect;

  if (!supportSVG) {
    return false;
  }

  opts = opts || {};
  elem.innerHTML = "\n    <svg class=\"kg-loading-svg ".concat(opts && opts.type ? "kg-loading-" + opts.type : "", "\" viewBox=\"0 0 88 88\" version=\"1.1\">\n        <circle class=\"kg-loading-BG\" cx=\"44\" cy=\"44\" r=\"26\" stroke=\"none\"/>\n        <g class=\"kg-loading-K\" fill=\"none\" stroke-width=\"7\" stroke-linecap=\"round\">\n            <line x1=\"39.2\" y1=\"35.5\" x2=\"39.2\" y2=\"51.5\"/>\n            <polyline points=\"50.1 35.6 41.3 43.4 50.2 50.8\"/>\n        </g>\n        <g class=\"kg-loading-R\" fill=\"none\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-dasharray=\"220.1\" stroke-dashoffset=\"220\">\n            <circle class=\"kg-loading-C\" cx=\"44\" cy=\"44\" r=\"35\" transform=\"translate(88,88) rotate(180)\"/>\n            <circle class=\"kg-loading-C\" cx=\"44\" cy=\"44\" r=\"35\"/>\n        </g>\n    </svg>\n    ");

  var changeOptions = function changeOptions(options) {
    var svg = elem.querySelector(".kg-loading-svg");
    var list = [];

    for (var i = 0; i < svg.classList.length; i++) {
      list.push(svg.classList[i]);
    }

    for (var i = 0; i < list.length; i++) {
      svg.classList.remove(list[i]);
    }

    svg.classList.add("kg-loading-svg");

    if (options && options.type) {
      svg.classList.add("kg-loading-" + options.type);
    }
  };

  setTimeout(function () {
    changeOptions(opts);
  }, 100);
  return {
    changeOptions: changeOptions
  };
};
/**
 * 获取DOM HTML
 * @param {Object} options 
 */


var getHTML = function getHTML(options) {
  var getLoadClass = function getLoadClass() {
    var classlist = ["kg-loading"]; //显示类型

    if (options.type) {
      classlist.push(options.type);
    } //是否弹窗


    if (options.showPop) {
      classlist.push('pop');
    } // 是否显示弹窗背景


    if (options.popConfig.showBg) {
      classlist.push('popBg');
    } //是否红菊


    if (options.showLongLoad) {
      classlist.push('longLoad');
    }

    return classlist.join(" ");
  };

  var getColor = function getColor(color, styles) {
    return color ? "".concat(styles ? styles : 'background-color', ":").concat(color, ";") : '';
  };

  var kgLoad = document.createElement("div");
  kgLoad.className = getLoadClass();
  kgLoad.innerHTML = "\n        <div class=\"kg-loading-container\" style=\"".concat(getColor(options.popConfig.popColor), "\">\n            <div class=\"kg-loading-icon ").concat(options.icon || '', "\"></div>\n            <div class=\"kg-loading-msg\" style=\"").concat(options.msg && 'margin-left: .1em;', "\"><span style=\"").concat(getColor(options.color, "color"), "\">").concat(options.msg || '', "</span></div>\n        </div>\n        <div class=\"kg-loading-bg\" style=\"").concat(getColor(options.popConfig.bgColor), "\"></div>\n    ");
  kgLoad.style.fontSize = Math.min(document.querySelector("html").offsetWidth / 7.2, 60) + "px";
  return kgLoad;
};
/**
 * 获取DOM容器
 * @param {Object} options 
 */


var getEle = function getEle(options) {
  if (options.ele) {
    if (typeof options.ele == "string") {
      return document.getElementById(options.ele);
    } else {
      return options.ele;
    }
  } else {
    var rand = document.createElement("div");
    rand.id = "kg-loading-" + new Date().getTime();
    rand.className = options.showPop ? "kg-loading-wrap" : "";
    document.body.appendChild(rand);
    return rand;
  }
};
/**
 * 删除DOM节点
 * @param {Object} ele 
 */


var removeEle = function removeEle(ele) {
  if (ele.getElementsByClassName("kg-loading").length > 0) {
    ele.removeChild(ele.getElementsByClassName("kg-loading")[0]);

    if (ele.id && /kg-loading/.test(ele.id)) {
      document.body.removeChild(ele);
    }
  }
};
/**
 * 后置处理
 * @param {Object} ele 
 * @param {Object} options 
 */


var postProcess = function postProcess(ele, options) {
  if (options.icon == 'blue_v3') {
    var canvas = ele.getElementsByClassName('blue_v3')[0];

    if (options.showLongLoad) {
      var obj = kg11Init(canvas);

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2({}, options, {}, {
          icon: 'blue'
        }));
      } else {
        setTimeout(function () {
          obj.changeOptions({
            type: "warn"
          });
          ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
        }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
      }
    } else {
      var obj = kg11Init(canvas);

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2({}, options, {}, {
          icon: 'blue'
        }));
      }
    }
  }

  if (options.icon == 'red_v3') {
    var _canvas = ele.getElementsByClassName('red_v3')[0];
    var obj = kg11Init(_canvas, {
      type: "warn"
    });

    if (obj == false) {
      //加载失败降级
      downGrade(ele, _objectSpread2({}, options, {}, {
        icon: 'red'
      }));
    }
  }

  if (options.icon == 'blue_v2') {
    var _canvas2 = ele.getElementsByClassName('blue_v2')[0];

    if (options.showLongLoad) {
      var obj = iconInit(_canvas2);

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2({}, options, {}, {
          icon: 'blue'
        }));
      } else {
        setTimeout(function () {
          obj.changeOptions({
            color: "error"
          });
          ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
        }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
      }
    } else {
      var obj = iconInit(_canvas2);

      if (obj == false) {
        //加载失败降级
        downGrade(ele, _objectSpread2({}, options, {}, {
          icon: 'blue'
        }));
      }
    }
  }

  if (options.icon == 'red_v2') {
    var _canvas3 = ele.getElementsByClassName('red_v2')[0];
    var obj = iconInit(_canvas3, {
      color: "error"
    });

    if (obj == false) {
      //加载失败降级
      downGrade(ele, _objectSpread2({}, options, {}, {
        icon: 'red'
      }));
    }
  }

  if (options.icon == "blue") {
    if (options.showLongLoad) {
      setTimeout(function () {
        ele.getElementsByClassName("kg-loading-icon")[0].className += ' red';
        ele.getElementsByClassName("kg-loading-msg")[0] && (ele.getElementsByClassName("kg-loading-msg")[0].innerHTML = "<span>".concat(options.longLoadConfig.msg || '加载缓慢', "</span>"));
      }, Math.ceil(options.longLoadConfig.time / 1000) * 1000 || 3000);
    }
  }

  if (options.time && options.time > 0) {
    setTimeout(function () {
      removeEle(ele);
    }, options.time);
  }
};
/**
 * 降级处理
 * @param {Object} ele 
 * @param {Object} options 
 */


var downGrade = function downGrade(ele, options) {
  removeEle(ele);
  var DomEle = getEle(options);
  var DomHtml = getHTML(options);
  DomEle.appendChild(DomHtml);
  postProcess(DomEle, options);
};
/**
 * 统一loading组件
 * 
 * @param {JSON} options 
 * @field type 显示类型（inline：并列显示 block：块显示）
 * @field msg 消息内容 
 * @field time 显示时长（不指定无限长 毫秒）
 * @field ele DOM容器（DOM ID/对象）
 * @field icon 显示的ICON(blue red blue_v2 red_v2)
 * @field color 显示颜色（RGBA）
 * 
 * @field showPop 是否浮窗显示
 * @field popConfig 浮窗配置
 * @field popConfig-showBg 浮窗背景显示
 * @field popConfig-popColor 浮窗颜色（RGBA）
 * @field popConfig-bgColor 浮窗背景颜色（RGBA）
 * 
 * @field showLongLoad 是否显示红菊
 * @field longLoadConfig 红菊配置
 * @field longLoadConfig-time 加载多少毫秒后显示红菊
 * @field longLoadConfig-msg 显示红菊时的文案
 */


function kgLoad() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options = _objectSpread2({}, {
    popConfig: {}
  }, {}, {
    longLoadConfig: {}
  }, {}, {
    type: 'inline',
    icon: 'blue',
    showPop: false,
    showLongLoad: false,
    color: !options.color && options.showPop ? "white" : "black"
  }, {}, options);
  var DomEle = getEle(options);

  if (options.time == -1) {
    return removeEle(DomEle);
  }

  var DomHtml = getHTML(options);
  DomEle.appendChild(DomHtml);
  postProcess(DomEle, options);
  return DomEle;
}

export default kgLoad;